<div class="modal-header border-bottom-0">
    <h5 class="modal-title fw-bold">
        <i class="fas fa-robot me-2"></i>Automatizar periodo
    </h5>
    <button type="button" class="btn-close" (click)="dismiss.emit()"></button>
</div>
<div class="modal-body">
    <p class="text-muted small">
        Si está activa, el día siguiente al cierre se cierra el mes, se crea el siguiente y se generan sus cobros.
        Si ese día cae sábado, domingo o feriado nacional, el cierre y los correos pasan al siguiente día hábil.
        Los PDF salen a la hora de correos.
    </p>
    <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" id="periodAuto"
               [ngModel]="config().isActive"
               (ngModelChange)="onToggle($event)">
        <label class="form-check-label fw-bold" for="periodAuto">
            {{ config().isActive ? 'Activada' : 'Desactivada' }}
        </label>
    </div>
    @if (!config().isActive) {
        <p class="small text-warning mb-3">
            El horario no se ejecuta hasta que esté <strong>Activada</strong> y pulses <strong>Guardar</strong>.
        </p>
    }
    <div class="row g-3">
        <div class="col-md-4">
            <label class="form-label fw-bold small text-uppercase text-muted">Último día del periodo</label>
            <input type="number" class="form-control" min="1" max="27"
                   [ngModel]="config().closeDay"
                   (ngModelChange)="onCloseDayChange($event)">
        </div>
        <div class="col-md-4">
            <label class="form-label fw-bold small text-uppercase text-muted">Cierre (Chile)</label>
            <div class="d-flex align-items-center gap-1">
                <input type="number" class="form-control" min="0" max="23" placeholder="HH" aria-label="Hora de cierre"
                       [ngModel]="config().runHour"
                       (ngModelChange)="onRunHourChange($event)">
                <span class="fw-bold">:</span>
                <input type="number" class="form-control" min="0" max="59" placeholder="MM" aria-label="Minutos de cierre"
                       [ngModel]="config().runMinute"
                       (ngModelChange)="onRunMinuteChange($event)">
            </div>
        </div>
        <div class="col-md-4">
            <label class="form-label fw-bold small text-uppercase text-muted">Correos (Chile)</label>
            <div class="d-flex align-items-center gap-1">
                <input type="number" class="form-control" min="0" max="23" placeholder="HH" aria-label="Hora de correos"
                       [ngModel]="config().mailHour"
                       (ngModelChange)="onMailHourChange($event)">
                <span class="fw-bold">:</span>
                <input type="number" class="form-control" min="0" max="59" placeholder="MM" aria-label="Minutos de correos"
                       [ngModel]="config().mailMinute"
                       (ngModelChange)="onMailMinuteChange($event)">
            </div>
        </div>
    </div>
    <p class="small text-muted mt-3 mb-1">
        El día <strong>{{ runDay() }}</strong> a las
        <strong>{{ timeLabel(config().runHour, config().runMinute) }}</strong>
        se cierra el mes, se crea el siguiente y se generan sus cobros.
        Si ese día no es hábil en Chile, se corre al siguiente día hábil.
    </p>
    <p class="small text-muted mb-2">
        Los correos con el PDF salen ese mismo día hábil a las
        <strong>{{ timeLabel(config().mailHour, config().mailMinute) }}</strong>.
    </p>
    <p class="small mb-0">{{ lastRunLabel() }}</p>
</div>
<div class="modal-footer border-top-0 d-flex justify-content-between rounded-bottom">
    <button type="button"
            class="btn btn-outline-secondary btn-sm"
            (click)="runNow()"
            [disabled]="isRunning() || !canRun()">
        @if (isRunning()) {
            <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Ejecutar ahora
    </button>
    <div>
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="dismiss.emit()">Cancelar</button>
        <button type="button" class="btn btn-primary btn-sm ms-2" (click)="save()" [disabled]="isSaving()">
            @if (isSaving()) {
                <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Guardar
        </button>
    </div>
</div>
